<template>
  <Loading v-if="!contact" />

  <div
    class="mt-12 xl:mt-24 layout-padding grid grid-cols-2 gap-20 mb-60"
    v-else
  >
    <div class="col-span-2 lg:col-span-1">
      <div
        class="contact-banner-image rounded-3xl"
        style="background: url(/static/images/contact.jpg)"
      >
      </div>
    </div>
    <div class="col-span-2 lg:col-span-1 flex flex-col justify-center relative">
      <div class="contact-underlay uppercase text-8xl " style="color: whitesmoke;">{{ content.contactUs }}</div>
      <div class="contact-title  text-6xl text-safetyBlack">{{ content.getInTouch }}</div>
      <div class="contact-info mt-20 ">
        <div class="text-2xl">
          {{ content.callUsOn }}
          <span class="phone text-3xl ml-2"> {{ contact[0].phone }}</span>
        </div>
        <div class="text-2xl">
          {{ content.emailUsOn }}
          <span class="email ml-2"> {{ contact[0].email }} </span>
        </div>
        <div class="text-2xl">
          {{ content.weAreHere }}
          <span class="address ml-2"> {{ contact[0].address }} </span>
        </div>
        <div class="text-2xl">
          {{ content.followUsOn
          }}<span class="social ml-2" >
            <a
            style="color: black !important;"
              href="https://www.linkedin.com/in/bright-flame-66b248226/"
              target="_blank"
            >
              LinkedIn</a
            >
          </span>
        </div>
      </div>
    </div>
  </div>
  <TheFooter />
</template>
<script>
export default {
  inject: ["content"],
  created() {
    document.getElementById("main-header").classList.add("bg-primary2");
  },
  beforeUnmount() {
    document.getElementById("main-header").classList.remove("bg-primary2");
  },
  methods: {
    async loadData() {
      if (!this.contact) await this.$store.dispatch("contact/getContact");
    },
  },
  computed: {
    contact() {
      return this.$store.getters["contact/contacts"];
    },
  },
  mounted() {
    this.loadData();
  },
};
</script>